import React from 'react';
import MainPage from '../components/MainPage.react';
import ProgressHeader from '../components/ProgressHeader.react';
import { AutoSizer } from 'react-virtualized';

export default class ModelBuilder extends React.Component {
  render(){
    return (
      <MainPage>
        <h4>
          BlueLabs Model Builder
        </h4>
        <AutoSizer>
          {({ width }) => (
            <ProgressHeader
              width={width - 40}
              height={100}
              currentStage={3}
              totalStages={5}
            />
          )}
        </AutoSizer>
      </MainPage>
    );
  }
}
